
import axios from 'axios';
import { api } from '../../api'
import getToken from '../../hook/getToken';


export const GET_DATA = "GET_DATA"
export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS'
export const GET_DATA_FAILURE = 'GET_DATA_FAILURE'

export const get_data = () => ({ type: GET_DATA })
export const get_data_success = (data) => ({ type: GET_DATA_SUCCESS, payload: data, })
export const get_data_failure = () => ({ type: GET_DATA_FAILURE })




export function all_data(id) {
    return async dispatch => {
        dispatch(get_data())
        try {
            const res = await axios.get(`${api}/sections/index.php?lesson_id=${id}`,{
                headers: {
                    'Authorization': getToken('accessToken'),
                }
            })
            if(res.data.status === 0) return window.location.reload()
            const data = await res.data.data
            dispatch(get_data_success(data))
        }
        catch (error) {
            dispatch(get_data_failure())
        }
    }
}

export async function deleteRecord(value) {
    let res = await axios.get(`${api}/sections/index.php?delete_id=${value}`,{
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}

export async function addSection(data) {
    let res = await axios.post(`${api}/sections/index.php`, data, {
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}

export async function editSection(data) {
    let res = await axios.post(`${api}/sections/update.php`, data, {
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}

export async function getData(value) {
    let res = await axios.get(`${api}/sections/index.php?section_id=${value}`,{
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}





